import script from "./SearchPill.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPill.vue?vue&type=script&setup=true&lang=js"

import "./SearchPill.vue?vue&type=style&index=0&id=2af664db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af664db"]])

export default __exports__